import { defineStore } from 'pinia'
import api from '@api/client'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('auth_token'),
    loading: false,
    error: null
  }),

  getters: {
    isAuthenticated: (state) => !!state.token && !!state.user,
    isAdmin: (state) => state.user?.role === 'admin',
    isEmployee: (state) => state.user?.role === 'employee',
    isVipAdmin: (state) => state.user?.role === 'vipadmin',
    companyId: (state) => state.user?.companyId
  },

  actions: {
    async init() {
      if (this.token) {
        try {
          this.loading = true
          const data = await api.get('/auth/me')
          this.user = data.user
        } catch (error) {
          this.logout()
        } finally {
          this.loading = false
        }
      }
    },

    async loginEmployee(companyId, empId, password) {
      this.loading = true
      this.error = null
      try {
        const data = await api.post('/auth/employee/login', {
          companyId,
          empId,
          password
        })
        this.setAuth(data)
        return data
      } catch (error) {
        this.error = error.message
        throw error
      } finally {
        this.loading = false
      }
    },

    async loginAdmin(companyId, password) {
      this.loading = true
      this.error = null
      try {
        const data = await api.post('/auth/admin/login', {
          companyId,
          password
        })
        this.setAuth(data)
        return data
      } catch (error) {
        this.error = error.message
        throw error
      } finally {
        this.loading = false
      }
    },

    async loginVipAdmin(username, password) {
      this.loading = true
      this.error = null
      try {
        const data = await api.post('/auth/vipadmin/login', {
          username,
          password
        })
        this.setAuth(data)
        return data
      } catch (error) {
        this.error = error.message
        throw error
      } finally {
        this.loading = false
      }
    },

    setAuth(data) {
      this.token = data.token
      this.user = data.user
      localStorage.setItem('auth_token', data.token)
    },

    setUser(user) {
      this.user = user
    },

    setToken(token) {
      this.token = token
      localStorage.setItem('auth_token', token)
    },

    async logout() {
      try {
        await api.post('/auth/logout')
      } catch (error) {
        // Ignore
      } finally {
        this.token = null
        this.user = null
        this.error = null
        localStorage.removeItem('auth_token')
      }
    }
  }
})
